import React, { Component } from 'react'
import { Trail, animated } from 'react-spring'
import E from 'utils/emitter'

import Header from 'components/sections/Header'

import { tagline } from 'data'
import styles from './styles.module.scss'

class Hero extends Component {
  state = {
    coords: [null, null],
    words: tagline,
  }

  offset = {
    top: 0,
  }

  componentDidMount() {
    E.on('resize', this.compute)
  }

  componentWillUnmount() {
    E.off('resize', this.compute)
  }

  onMouseMove = (e) => {
    this.setPos(e.pageX, e.pageY)
  }

  onMouseOut = (e) => {
    this.setPos(35, this.offset.top + 35)
  }

  setPos = (x, y) => {
    this.setState({
      coords: [x, y],
    })
  }

  compute = () => {
    const scrollY = -window.pageYOffset || -document.documentElement.scrollTop
    const rect = this.tagline.getBoundingClientRect()

    this.offset = {
      top: rect.top - scrollY,
      left: rect.left,
    }

    this.setPos(35, this.offset.top + 35)
  }

  render() {
    const { words } = this.state

    const transform = (x, y) =>
      `translate3d(${x - 35}px, ${y - this.offset.top - 35}px, 0)`

    return (
      <section
        className={styles.hero}
        onMouseMove={this.onMouseMove}
        onMouseOut={this.onMouseOut}
      >
        <Header />

        <div className={styles.wrapper}>
          <h2
            ref={(el) => el && (this.tagline = el)}
            className={styles.tagline}
          >
            <Trail
              items={words}
              to={this.state}
              config={{
                tension: 900,
                friction: 40,
                precision: 0.1,
              }}
              native
            >
              {(item, i) => (props) => (
                <animated.span
                  className={styles.word}
                  style={{
                    zIndex: words.length - i,
                    transform: props.coords.interpolate(transform),
                  }}
                >
                  {item}
                </animated.span>
              )}
            </Trail>
          </h2>
        </div>
      </section>
    )
  }
}

export default Hero
